'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var dateTimeFormatting = require('./dateTimeFormatting-5ee7d54c.js');
var calendarView_styles = require('./calendar-view.styles-be23bcc4.js');
var dayLabels_styles = require('./day-labels.styles-152dcd41.js');

var DayLabels = function (_a) {
    var locale = _a.locale, size = _a.size, variant = _a.variant;
    var dayLabels = dateTimeFormatting.getWeekDaysLabels(locale);
    return (React__default.createElement(calendarView_styles.DaysLayout, { className: "week-day-names", "data-testid": "week-day-names", variant: variant }, dayLabels.map(function (day) { return (React__default.createElement(dayLabels_styles.DayLabel, { key: day, className: "week-day-label " + day, "data-cy": day + "-label", "data-testid": day + "-label", size: size, variant: variant }, day)); })));
};

exports.DayLabels = DayLabels;
